import InputMask from "react-input-mask";
import { FormControl } from "react-bootstrap";

export default function PhoneInput(props) {
    return (
        <InputMask
            mask="999 999 999"
            value={props.value}
            onChange={props.onChange}
        >
            {inputProps => <FormControl {...inputProps} fullWidth />}
        </InputMask>
    )
}